<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.recipes') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <RecipeForm
        :warehouses="warehouses"
        :products="products"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        @onSubmit="handleSubmit"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import RecipeForm from '../../../combine/RecipeForm.vue'

export default {
  mixins: [discardFormMixin],

  components: {
    RecipeForm,
  },

  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
    }
  },

  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      warehouses: 'getWarehouses',
      products: 'getProducts',
    }),
  },

  async mounted () {
    await this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 6,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
      submenuAtIdx: 1,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, ['clearProducts'])
  },

  methods: {
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('getProducts'),
        this.$store.dispatch('getWarehouses'),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getFormData (form = {}) {
      return {
        'name': form.name,
        'stock_skus': form.stockSkus.map((stockSkuItem) => {
          return {
            'sku_id': stockSkuItem.location_data.sku_id,
            'wh_id': stockSkuItem.location_data.wh_id,
            'stock_id': stockSkuItem.location_data.stock_id,
            'bin_location_id': stockSkuItem.location_data.bin_location_id,
            'required_unit': Number(stockSkuItem.required_unit),
          }
        }),
        'assign_skus': form.assignSkus.map((assignSkuItem) => {
          return {
            'sku_id': assignSkuItem.value,
          }
        }),
      }
    },
    async handleSubmit (form = {}) {
      this.isSubmitted = true
      this.disabled = true
      const data = this.getFormData(form)
      const response = await this.$store.dispatch('insertRecipe', { data })
      if (response.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({ name: 'RecipeAll' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/recipe/New.vue